import React from 'react';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import * as echarts from 'echarts';

interface IPieChart {
    chartData: Array<{ value: number, name: string }>;
    totalSessions?: number;
    colors?: Array<string>;
}

const CustomPieChart = ({ chartData, colors, totalSessions }: IPieChart) => {
    const getOptionBar = () => ({
        tooltip: {
            trigger: 'item',
            formatter: (params: any) => {
                const { name, value } = params;
                return `${name}: ${value} %`;
            }
        },
        legend: {
            bottom: '0',
            left: 'center',
            icon: 'circle',
            itemGap: 20,
            padding: [2, 0, 2, 0]
        },
        series: [
            {
                name: 'Transactions',
                type: 'pie',
                radius: ['40%', '50%'],
                data: chartData || [],
                label: {
                    show: false,
                    position: 'center'
                },
                color: colors || ['#008000', '#FF0000',],
                startAngle: 15,
                emphasis: {
                    scale: true,
                    label: {
                        show: false
                    }
                },
            },
        ],
        graphic: [
            {
                type: 'text',
                left: 'center',
                top: 'center',
                style: {
                    text: `{a|${totalSessions || 0}}\n{b|Transactions}`, // Styled text
                    textAlign: 'center',
                    rich: {
                        a: {
                            fontSize: 28,
                            fill: '#000'
                        },
                        b: {
                            fontSize: 14,
                            fill: '#000'
                        }
                    }
                }
            }
        ]
    })
    return (
        <div>
            <ReactEcharts option={getOptionBar()} style={{ height: 350, width: '100%' }} />
        </div>
    )
}
export default CustomPieChart;